<label
  *ngIf="showSubscription()"
  class="subscription-card"
  [ngClass]="{ 'subscription-card--selected': isSelected() }"
>
  <div class="subscription-card__main">
    <input
      type="radio"
      [checked]="isSelected()"
      [disabled]="disabled()"
      class="subscription-card__radio-input"
      (change)="payWithCard.emit()"
    />

    <div class="subscription-card__content">
      <div class="subscription-card__header">
        <h3 class="subscription-card__title">Pago automático con tarjeta</h3>
        <div class="subscription-card__tag">¡Recomendado!</div>
      </div>

      <p class="subscription-card__terms">
        Al elegir este medio de pago, <strong>autorizas el débito automático mensual</strong> del valor de tu seguro
        desde tu tarjeta.
      </p>

      <p class="subscription-card__terms">
        Aplican
        <a
          class="subscription-card__terms-link"
          [href]="termsUrl"
          target="_blank"
          rel="noopener noreferrer"
          >Términos y Condiciones</a
        >.
      </p>
    </div>
  </div>

  <div *ngIf="showPromo()" class="subscription-card__promo">
    <div class="subscription-card__promo-logo" aria-hidden="true">PC</div>

    <div class="subscription-card__promo-content">
      <h4 class="subscription-card__promo-title">
        Recibe 2.000 Puntos Colombia por la activación del débito automático.
      </h4>
      <p class="subscription-card__promo-terms">
        Aplican
        <a
          class="subscription-card__promo-terms-link"
          [href]="termsUrl"
          target="_blank"
          rel="noopener noreferrer"
          >Términos y condiciones</a
        >.
      </p>
    </div>
  </div>
</label>
